// The same phone login as the app: a code by SMS, then a lab session, an
// access token that lives an hour and a refresh token that renews it for a
// day. Only admin
// users get past the sign-in page; the API refuses everyone else anyway.
const KEY = 'lab.auth'

export interface Auth {
  accessToken: string
  refreshToken: string
}

export function getAuth(): Auth | null {
  const raw = localStorage.getItem(KEY)
  return raw ? (JSON.parse(raw) as Auth) : null
}
export const setAuth = (auth: Auth) =>
  localStorage.setItem(KEY, JSON.stringify(auth))
export const clearAuth = () => localStorage.removeItem(KEY)

// Why the last session ended, kept for one page load so the sign-in page can
// say it. Storage can be blocked; the sign-in page then shows nothing.
const NOTICE = 'lab.notice'
export function setSignOutNotice(message: string) {
  try {
    sessionStorage.setItem(NOTICE, message)
  } catch {}
}
export function takeSignOutNotice(): string | null {
  try {
    const message = sessionStorage.getItem(NOTICE)
    sessionStorage.removeItem(NOTICE)
    return message
  } catch {
    return null
  }
}

export function decodeJwt(token: string): { globalRole?: string } | null {
  try {
    const payload = token.split('.')[1] ?? ''
    return JSON.parse(atob(payload.replace(/-/g, '+').replace(/_/g, '/')))
  } catch {
    return null
  }
}

// Lab is for admins. The API decides (it reads the role from its database on
// every request); this only spares anyone else an empty console.
export function isAdmin(token: string): boolean {
  return decodeJwt(token)?.globalRole === 'admin'
}
